/* Ghost Members Portal i18n: reload portal per locale + tier copy from YOBY_PORTAL_TIERS */
(function () {
    var STORAGE_KEY = 'paperverso_locale';
    var LOCALES = window.YOBY_SUPPORTED_LOCALES || ['it', 'fr', 'es', 'pt', 'en', 'de', 'nl'];
    var PORTAL_TIERS = window.YOBY_PORTAL_TIERS || {};

    var GHOST_LOCALE_TAGS = {
        it: 'it',
        fr: 'fr',
        es: 'es',
        pt: 'pt-BR',
        en: 'en',
        de: 'de'
    };

    var portalInitLocale = null;
    var portalReloading = false;
    var portalRootObserver = null;
    var portalIframeHookObserver = null;
    var portalContentObserver = null;
    var portalIframeLoadHooked = null;
    var applyingPortalTranslations = false;
    var portalMutationDebounce = null;

    function normalizeLocale(input) {
        if (!input) return 'en';
        var key = String(input).trim().toLowerCase().replace(/_/g, '-');
        if (LOCALES.indexOf(key) >= 0) return key;
        var base = key.split('-')[0];
        if (LOCALES.indexOf(base) >= 0) return base;
        var aliases = { 'pt-br': 'pt', 'pt-pt': 'pt', 'en-us': 'en', 'en-gb': 'en' };
        return aliases[key] || aliases[base] || 'en';
    }

    function getActiveLocale() {
        try {
            var v = localStorage.getItem(STORAGE_KEY);
            if (v && LOCALES.indexOf(v) >= 0) return v;
        } catch (e) { /* ignore */ }
        if (window.__YOBY_GHOST_LOCALE && LOCALES.indexOf(window.__YOBY_GHOST_LOCALE) >= 0) {
            return window.__YOBY_GHOST_LOCALE;
        }
        return normalizeLocale(document.documentElement.lang || 'en');
    }

    function ghostLocaleTag(locale) {
        return GHOST_LOCALE_TAGS[locale] || locale;
    }

    function normalizeText(s) {
        return String(s || '').replace(/\s+/g, ' ').trim();
    }

    function portalNeedsReload() {
        return portalInitLocale !== getActiveLocale();
    }

    function getPortalConfig() {
        var root = document.documentElement;
        return {
            src: root.getAttribute('data-yoby-portal-src') || 'https://cdn.jsdelivr.net/ghost/portal@~2.69/umd/portal.min.js',
            ghost: root.getAttribute('data-yoby-ghost') || '',
            key: root.getAttribute('data-yoby-content-key') || '',
            api: root.getAttribute('data-yoby-content-api') || ''
        };
    }

    function getPortalRoot() {
        return document.getElementById('ghost-portal-root');
    }

    function getPortalIframe() {
        var root = getPortalRoot();
        if (!root) return null;
        return root.querySelector('iframe[data-yoby-auth-frame], iframe[title="portal-popup"]') ||
            root.querySelector('iframe.gh-portal-popup-iframe') ||
            root.querySelector('iframe');
    }

    function readPortalDocument() {
        var iframe = getPortalIframe();
        if (iframe) {
            try {
                if (iframe.contentDocument && iframe.contentDocument.body) {
                    return iframe.contentDocument;
                }
            } catch (e) { /* cross-origin */ }
        }
        if (document.querySelector('.gh-portal-product-card')) {
            return document;
        }
        return null;
    }

    function whenPortalDocumentReady(callback) {
        var iframe = getPortalIframe();
        if (!iframe) {
            callback(readPortalDocument());
            return;
        }

        function deliver() {
            callback(readPortalDocument());
        }

        if (readPortalDocument()) {
            deliver();
            return;
        }

        if (portalIframeLoadHooked !== iframe) {
            portalIframeLoadHooked = iframe;
            iframe.addEventListener('load', deliver, { once: true });
        }
    }

    function disconnectPortalContentObserver() {
        if (portalContentObserver) {
            portalContentObserver.disconnect();
            portalContentObserver = null;
        }
    }

    function hookPortalIframeContent() {
        whenPortalDocumentReady(function (portalDoc) {
            if (!portalDoc || !portalDoc.body) return;
            if (window.location.hash.indexOf('/portal/') < 0) return;

            disconnectPortalContentObserver();
            portalContentObserver = new MutationObserver(function () {
                if (applyingPortalTranslations) return;
                if (portalMutationDebounce) clearTimeout(portalMutationDebounce);
                portalMutationDebounce = setTimeout(function () {
                    portalMutationDebounce = null;
                    applyPortalTierTranslations();
                }, 80);
            });
            portalContentObserver.observe(portalDoc.body, {
                childList: true,
                subtree: true,
                characterData: true
            });
            applyPortalTierTranslations();
        });
    }

    function removePortalDom() {
        disconnectPortalContentObserver();
        portalIframeLoadHooked = null;
        ['ghost-portal-root', 'gh-portal-root'].forEach(function (id) {
            var el = document.getElementById(id);
            if (el) el.remove();
        });
        document.querySelectorAll('.gh-portal-popup').forEach(function (el) {
            el.remove();
        });
    }

    function injectPortalScript(done) {
        var cfg = getPortalConfig();
        if (!cfg.ghost || !cfg.key) {
            if (done) done();
            return;
        }

        var activeLocale = getActiveLocale();
        var ghostTag = ghostLocaleTag(activeLocale);

        removePortalDom();
        var old = document.getElementById('yoby-portal-script');
        if (old) old.remove();

        var script = document.createElement('script');
        script.defer = true;
        script.id = 'yoby-portal-script';
        script.src = cfg.src;
        script.setAttribute('data-i18n', 'true');
        script.setAttribute('data-ghost', cfg.ghost);
        script.setAttribute('data-key', cfg.key);
        script.setAttribute('data-api', cfg.api);
        script.setAttribute('data-locale', ghostTag);
        script.crossOrigin = 'anonymous';

        script.addEventListener('load', function () {
            portalInitLocale = activeLocale;
            portalReloading = false;
            ensurePortalRootObserver();
            if (done) done();
        }, { once: true });

        script.addEventListener('error', function () {
            portalReloading = false;
            if (done) done();
        }, { once: true });

        document.head.appendChild(script);
    }

    function reloadGhostPortal(done) {
        if (portalReloading) {
            window.addEventListener('yoby:portalreload', function onDone() {
                window.removeEventListener('yoby:portalreload', onDone);
                if (done) done();
            }, { once: true });
            return;
        }

        if (!portalNeedsReload() && getPortalRoot()) {
            if (done) done();
            return;
        }

        portalReloading = true;
        portalInitLocale = null;
        injectPortalScript(function () {
            try {
                window.dispatchEvent(new CustomEvent('yoby:portalreload'));
            } catch (e) { /* ignore */ }
            if (done) done();
        });
    }

    function ensurePortalLocale(callback) {
        window.__YOBY_GHOST_LOCALE = getActiveLocale();
        document.documentElement.lang = getActiveLocale();

        if (portalNeedsReload() || !document.getElementById('yoby-portal-script')) {
            reloadGhostPortal(callback || function () {});
            return;
        }

        var script = document.getElementById('yoby-portal-script');
        if (script) {
            script.setAttribute('data-locale', ghostLocaleTag(getActiveLocale()));
        }
        if (callback) callback();
    }

    function buildReplacementPairs() {
        var locale = getActiveLocale();
        if (locale === 'en') return [];

        var enDoc = PORTAL_TIERS.en;
        var locDoc = PORTAL_TIERS[locale];
        if (!enDoc || !locDoc) return [];

        var pairs = [];

        if (enDoc.signupTermsHtml && locDoc.signupTermsHtml && enDoc.signupTermsHtml !== locDoc.signupTermsHtml) {
            pairs.push([stripHtml(enDoc.signupTermsHtml), stripHtml(locDoc.signupTermsHtml)]);
        }

        if (!enDoc.tiers || !locDoc.tiers) return pairs;

        enDoc.tiers.forEach(function (enTier, i) {
            var locTier = locDoc.tiers[i];
            if (!locTier) return;

            function addPair(from, to) {
                if (!from || !to || from === to) return;
                pairs.push([from, to]);
            }

            addPair(enTier.name, locTier.name);
            addPair(enTier.description, locTier.description);
            addPair(enTier.trialBadge, locTier.trialBadge);
            (enTier.benefits || []).forEach(function (benefit, j) {
                addPair(benefit, locTier.benefits && locTier.benefits[j]);
            });
        });

        return pairs;
    }

    function stripHtml(html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        return normalizeText(tmp.textContent || tmp.innerText || '');
    }

    function patchSignupTerms(portalDoc, localeDoc) {
        if (!portalDoc || !localeDoc || !localeDoc.signupTermsHtml) return;
        var locHtml = String(localeDoc.signupTermsHtml).trim();
        if (!locHtml) return;

        portalDoc.querySelectorAll('.gh-portal-signup-terms-content').forEach(function (el) {
            var current = (el.innerHTML || '').trim();
            if (current === locHtml) return;
            el.innerHTML = locHtml;
        });
    }

    function replaceTextInNode(node, pairs) {
        if (!node || !pairs.length) return;
        var text = node.textContent;
        if (!text || !normalizeText(text)) return;
        var next = text;
        pairs.forEach(function (pair) {
            if (next.indexOf(pair[0]) >= 0) {
                next = next.split(pair[0]).join(pair[1]);
            }
        });
        if (next !== text) node.textContent = next;
    }

    function walkAndReplace(doc, root, pairs) {
        if (!doc || !root || !pairs.length) return;
        if (typeof doc.createTreeWalker !== 'function') return;
        var walker = doc.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
        var node;
        while ((node = walker.nextNode())) {
            replaceTextInNode(node, pairs);
        }
    }

    function tierLookupNames(tier, tierIndex) {
        var names = {};
        function add(name) {
            var key = normalizeText(name).toLowerCase();
            if (key) names[key] = true;
        }

        add(tier.matchName);
        add(tier.name);

        var enDoc = PORTAL_TIERS.en;
        if (enDoc && enDoc.tiers && enDoc.tiers[tierIndex]) {
            add(enDoc.tiers[tierIndex].matchName);
            add(enDoc.tiers[tierIndex].name);
        }

        LOCALES.forEach(function (loc) {
            var doc = PORTAL_TIERS[loc];
            if (!doc || !doc.tiers || !doc.tiers[tierIndex]) return;
            add(doc.tiers[tierIndex].matchName);
            add(doc.tiers[tierIndex].name);
        });

        return names;
    }

    function findTierCard(portalDoc, tier, tierIndex) {
        if (!portalDoc) return null;

        var lookup = tierLookupNames(tier, tierIndex);
        var cards = portalDoc.querySelectorAll('.gh-portal-product-card');
        for (var i = 0; i < cards.length; i += 1) {
            var stored = cards[i].getAttribute('data-yoby-tier-match');
            if (stored && lookup[normalizeText(stored).toLowerCase()]) {
                return cards[i];
            }
            var nameEl = cards[i].querySelector('.gh-portal-product-name');
            if (!nameEl) continue;
            if (lookup[normalizeText(nameEl.textContent).toLowerCase()]) {
                return cards[i];
            }
        }
        return null;
    }

    function patchTierCard(card, tier) {
        if (!card || !tier) return;
        var matchName = tier.matchName || tier.name;
        if (matchName) card.setAttribute('data-yoby-tier-match', matchName);

        var nameEl = card.querySelector('.gh-portal-product-name');
        if (nameEl && tier.name) nameEl.textContent = tier.name;

        var descEl = card.querySelector('.gh-portal-product-description');
        if (tier.description) {
            if (descEl) {
                descEl.textContent = tier.description;
            } else {
                var details = card.querySelector('.gh-portal-product-card-details');
                if (details) {
                    var created = card.ownerDocument.createElement('p');
                    created.className = 'gh-portal-product-description';
                    created.textContent = tier.description;
                    var benefits = details.querySelector('.gh-portal-product-benefits');
                    if (benefits) {
                        details.insertBefore(created, benefits);
                    } else {
                        details.appendChild(created);
                    }
                }
            }
        }

        if (Array.isArray(tier.benefits) && tier.benefits.length) {
            var benefitEls = card.querySelectorAll('.gh-portal-product-benefit');
            tier.benefits.forEach(function (text, idx) {
                if (!benefitEls[idx]) return;
                var spans = benefitEls[idx].querySelectorAll('span');
                if (spans.length) {
                    spans[spans.length - 1].textContent = text;
                } else {
                    benefitEls[idx].textContent = text;
                }
            });
        }

        if (tier.trialBadge) {
            var trialEl = card.querySelector('.gh-portal-discount-label-trial, .gh-portal-discount-label');
            if (trialEl) trialEl.textContent = tier.trialBadge;
        }
    }

    function applyPortalTierTranslations() {
        if (applyingPortalTranslations) return;

        var locale = getActiveLocale();
        if (locale === 'en') return;

        var doc = PORTAL_TIERS[locale] || PORTAL_TIERS.en;
        if (!doc) return;

        var hasTiers = doc.tiers && doc.tiers.length;
        var hasSignupTerms = !!doc.signupTermsHtml;
        if (!hasTiers && !hasSignupTerms) return;

        whenPortalDocumentReady(function (portalDoc) {
            if (!portalDoc || applyingPortalTranslations) return;

            applyingPortalTranslations = true;
            try {
                if (hasTiers) {
                    var cards = portalDoc.querySelectorAll('.gh-portal-product-card');
                    doc.tiers.forEach(function (tier, index) {
                        var card = cards[index] || findTierCard(portalDoc, tier, index);
                        if (card) patchTierCard(card, tier);
                    });
                }

                patchSignupTerms(portalDoc, doc);

                var pairs = buildReplacementPairs();
                var root = portalDoc.getElementById('ghost-portal-root') ||
                    portalDoc.querySelector('.gh-portal-popup-container') ||
                    portalDoc.body;
                if (root && pairs.length) walkAndReplace(portalDoc, root, pairs);
            } finally {
                applyingPortalTranslations = false;
            }
        });
    }

    function scheduleTierRetries() {
        [0, 50, 150, 300, 600, 1000, 2000, 3500, 5000].forEach(function (ms) {
            setTimeout(applyPortalTierTranslations, ms);
        });
    }

    function applyPortalI18n() {
        applyPortalTierTranslations();
    }

    function ensurePortalRootObserver() {
        if (window.location.hash.indexOf('/portal/') < 0) return;

        var root = getPortalRoot();
        if (!root) return;

        if (!portalRootObserver) {
            portalRootObserver = new MutationObserver(function () {
                hookPortalIframeContent();
            });
            portalRootObserver.observe(root, { childList: true, subtree: true });
        }

        if (!portalIframeHookObserver) {
            portalIframeHookObserver = new MutationObserver(function () {
                if (window.location.hash.indexOf('/portal/') < 0) return;
                if (getPortalRoot()) hookPortalIframeContent();
            });
            portalIframeHookObserver.observe(document.body, { childList: true, subtree: true });
        }

        hookPortalIframeContent();
    }

    function onPortalRoute() {
        if (window.location.hash.indexOf('/portal/') < 0) return;
        ensurePortalLocale(function () {
            ensurePortalRootObserver();
            scheduleTierRetries();
        });
    }

    function resolvePortalHashFromTarget(target) {
        if (!target) return null;
        var href = target.getAttribute('href');
        if (href && href.indexOf('#/portal/') >= 0) {
            return href.slice(href.indexOf('#'));
        }
        var action = target.getAttribute('data-portal');
        if (action) return '#/portal/' + action;
        return null;
    }

    function onPortalTriggerClick(e) {
        var target = e.target.closest('a[href*="#/portal/"], [data-portal]');
        if (!target) return;

        var hash = resolvePortalHashFromTarget(target);
        if (!hash) return;

        if (!portalNeedsReload()) return;

        e.preventDefault();
        e.stopImmediatePropagation();

        ensurePortalLocale(function () {
            scheduleTierRetries();
            if (window.location.hash !== hash) {
                window.location.hash = hash;
            } else {
                onPortalRoute();
            }
        });
    }

    window.YOBY_portalI18n = {
        apply: applyPortalI18n,
        getLocale: getActiveLocale,
        ensureLocale: ensurePortalLocale,
        reload: reloadGhostPortal
    };

    document.addEventListener('click', onPortalTriggerClick, true);

    document.addEventListener('DOMContentLoaded', function () {
        var script = document.getElementById('yoby-portal-script');
        if (script) {
            script.addEventListener('load', function () {
                portalInitLocale = getActiveLocale();
                ensurePortalRootObserver();
                if (window.location.hash.indexOf('/portal/') >= 0) {
                    scheduleTierRetries();
                }
            }, { once: true });
            if (getPortalRoot()) {
                portalInitLocale = getActiveLocale();
            }
        }
        ensurePortalRootObserver();
        applyPortalI18n();
        if (window.location.hash.indexOf('/portal/') >= 0) {
            onPortalRoute();
        }
    });

    window.addEventListener('hashchange', onPortalRoute);

    window.addEventListener('yoby:localechange', function () {
        var hash = window.location.hash;
        var wasPortal = hash.indexOf('/portal/') >= 0;
        portalInitLocale = null;
        window.__YOBY_GHOST_LOCALE = getActiveLocale();
        document.documentElement.lang = getActiveLocale();

        ensurePortalLocale(function () {
            scheduleTierRetries();
            if (wasPortal) {
                if (window.location.hash !== hash) {
                    window.location.hash = hash;
                } else {
                    onPortalRoute();
                }
            }
        });
    });
})();
